import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

import { dateRangeZodObject } from "@@/shared/date-time/date-range";
import { idZodSchema } from "@@/shared/id";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { headQuoteItemZodSchema } from "@@/shared/quotes/quote";
import { translatableZodSchema } from "@@/shared/translations/translation";

const quoteCreateCommandZodSchema = z.object({
    _id: idZodSchema, // The quote we want to edit
    _type: z.literal("CREATE_QUOTE_COMMAND"), // Command type

    providerId: providerIdZodSchema,
    title: translatableZodSchema,
    dateRange: dateRangeZodObject,
    customer: contactInfoZodObject,
    items: z.array(headQuoteItemZodSchema),
});
type QuoteCreateCommand = z.infer<typeof quoteCreateCommandZodSchema>;

type quoteCreateCommandFactoryParams = Except<
    QuoteCreateCommand,
    "_id" | "_type"
>;

const quoteCreateCommandFactory = (
    params: quoteCreateCommandFactoryParams,
): QuoteCreateCommand => {
    return {
        ...params,
        _id: generateId("create_command__"), // Or however you generate IDs
        _type: "CREATE_QUOTE_COMMAND",
    };
};

export { quoteCreateCommandFactory, quoteCreateCommandZodSchema };
export type { QuoteCreateCommand, quoteCreateCommandFactoryParams };
